var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n"),React.createElement("polygon",{"points":"12,2.1 9.9,0 6,3.9 2.1,0 0,2.1 3.9,6 0,9.9 2.1,12 6,8.1 9.9,12 12,9.9 8.1,6 ","key":1})]);
}

Close.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","viewBox":"0 0 12 12","style":{"enableBackground":"new 0 0 12 12"},"xmlSpace":"preserve"};

module.exports = Close;

Close.default = Close;
